const funcHeroPinBalloon = {

  timer: null,

  lastPins: [],

  funcInit: function () {
    const pins = document.querySelectorAll('.hero__pin');

    if (!pins.length) return;

    this.startRandomBalloon(pins);
  },

  startRandomBalloon: function (pins) {
    const changeBalloon = () => {
      const displayCount = Math.random() > 0.5 ? 2 : 1;

      let candidates = [...pins].filter(
        (pin) => !this.lastPins.includes(pin)
      );

      if (candidates.length < displayCount) {
        candidates = [...pins];
      }

      const shuffled = candidates.sort(
        () => Math.random() - 0.5
      );

      const targetPins = shuffled.slice(0, displayCount);

      pins.forEach((pin) => {
        pin.classList.remove('is-balloon');
      });

      setTimeout(() => {

        targetPins.forEach((pin) => {
          pin.classList.add('is-balloon');
        });

      }, 300);

      this.lastPins = targetPins;

      const nextTime = 5000 + Math.random() * 3000;
      this.timer = setTimeout(changeBalloon, nextTime);
    };
    changeBalloon();
  },
};

export default funcHeroPinBalloon;